import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { ViewIconISBAR } from "../../../../assets/CommonAssets";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import { ModalStyle } from "../../../../common/components/ModalStyle";
import { getHandoverOldList } from "./HandoverSummaryServices";
import CommonTransactionTable from "../../../../common/components/CommonTable/CommonTransactionTable";

// import {
//   getBenchmarkDropdown,
//   getDepartmentDropdown,
//   saveKpiIndicator,
// } from "./KPIIndicatorServices";
const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

const schema = yup.object({
  benchmark: yup.string().trim().required("Required"),
  department: yup.object().required("department is required"),
  indicator: yup.string().trim().required("Required"),
  benchmarkType: yup.object().required("department is required"),
});


const ISBARHandoverListingModal = ({
  handoverSummaryListingModal,
  setHandoverSummaryListingModal,
  selectedRow,
  setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
  admissionId,
}) => {
  const inputRef = useRef();
  const [openPostModal, setOpenPostModal] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);

  const [handoverListing, setHandoverListing] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  // const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);

  // const [openBackDrop, setOpenBackdrop] = useState(false);
  const [count, setCount] = useState(0);
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    setError,
    watch,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm();

  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <div className="flex gap-2 cursor-pointer">
                {actions.permission === "Delete" ? (
                  <ViewIconISBAR
                    title={"View Details"}
                    sx={{ color: "#D11A2A" }}
                    type={"button"}
                    onClick={() => {
                      setSelectedRow(row);
                      setHandoverSummaryListingModal(false);
                    }}
                  />
                ) : null}
              </div>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${
                       row?.status === true
                         ? "text-customGreen border-customGreen"
                         : "text-customRed border-customRed"
                     }`}
            type="button"
          >
            {row?.status === true ? "Active" : "InActive"}
          </button>
        )}
      </>
    );
  };
  const rowBackgroundColor = (row, index) => {
    return row?.["isFormula"] ? "#a3b3ff" : "#ffffff";
  };
  const onSubmit = (data) => {};
  useEffect(() => {
    if (admissionId) {
      getHandoverOldList(admissionId)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            setHandoverListing(res?.result);
          }
        })
        .catch((error) => console.log(error));
    }
  }, []);
  return (
    <>
      <Modal
        open={handoverSummaryListingModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={ModalStyle} className="  rounded-xl w-[80%] h-[90vh]">
            <div className="flex justify-between items-center pb-2">
              <h1 className="font-bold text-[16px] text-gray-800 tracking-wide">
                ISBAR Handover List
              </h1>
              <div className="flex ">
                <CloseModalIcon
                  type="button"
                  className="closeButton"
                  onClick={() => {
                    setHandoverSummaryListingModal(false);
                    setSelectedRow(null);
                    // reset(defaultValues);
                  }}
                />
              </div>
            </div>

            <CommonDivider color="E0E0E0" />
            <div>
              {" "}
              {handoverListing?.length > 0 && !spinner ? (
                <CommonTransactionTable
                  page={page}
                  rowsPerPage={rowsPerPage}
                  setPage={setPage}
                  // populateTable={populateTable}
                  count={count}
                  highlightRow={false}
                  dataResult={handoverListing}
                  renderActions={renderActions}
                  renderInput={renderInput}
                  editableColumns={"status"}
                  removeHeaders="AdmissionId"
                  tableClass="capitalize max-h-[500px] overflow-scroll"
                />
              ) : (
                <>
                  {!spinner && (
                    <div className="flex justify-center">
                      <h3 className="flex justify-center mt-40 font-bold text-gray-600">
                        No Records Found...
                      </h3>
                    </div>
                  )}
                </>
              )}
            </div>
          </Box>
          {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
        </form>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure you want to ${
          selectedRow !== null ? "update" : "save"
        } this record?`}
        confirmationSubmitFunc={() => {}}
        confirmationButtonMsg="Save"
      />
    </>
  );
};

export default ISBARHandoverListingModal;